/*eslint-disable*/
require("./src/styles/global.css")

const React = require("react")
const Layout = require("./src/components/Layout/MainLayout").default

export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>
